import type { ReactNode } from "react"
import { cn } from "../utils/cn"

type Props = {
  label: string
  error?: string
  children: ReactNode
  hint?: string
}

export function Field({ label, error, children, hint }: Props) {
  return (
    <label className="block">
      <span className="label-base">{label}</span>
      {children}
      {hint ? <span className="mt-2 block text-xs text-slate-500">{hint}</span> : null}
      {error ? <span className={cn("mt-2 block text-sm text-rose-600")}>{error}</span> : null}
    </label>
  )
}
